import { ArrowRight } from "lucide-react";

const ITEMS = ["TRAFFIC", "LEADS", "APPOINTMENTS", "CUSTOMERS", "REPEAT CUSTOMERS"];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {Array.from({ length: 3 }).flatMap((_, r) =>
            ITEMS.map((t, i) => (
                <span key={`${r}-${i}`} className="flex items-center">
                    <span className="mx-7 font-display text-lg font-bold tracking-wide md:text-xl">{t}</span>
                    <ArrowRight className="text-hl" size={18} />
                </span>
            ))
        )}
    </div>
);

export const Marquee = () => (
    <div data-testid="editorial-marquee" className="relative z-10 my-8 -rotate-1 scale-[1.02] overflow-hidden border-y-2 border-ink bg-ink py-3.5 text-paper">
        <div className="marquee-track flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);
